/* Generic clip-and-reveal for any [data-bs-collapse]: clipped to a fixed height (--bs-collapse-h, from its
   data-bs-collapse-height attribute) with a bottom fade and a "See all" button (a [data-bs-collapse-toggle] inside
   the same parent) whenever its content is taller than that height; no fade and no button when it fits.
   The content is measured on the .bs-collapse-inner wrapper with a ResizeObserver, for the life of the page:
   Loox builds its widget late, its iframe resizes itself and its photos load one by one, so the answer to
   "does it fit?" changes several times after first paint. (It used to be decided once, early, which left a hard
   clip with no fade and no button whenever Loox finished growing after the check.)
   Until the first measurement the default is the collapsed state (fade and button showing), never a bare clip.
   Closing scrolls the section's top back into view so the reader isn't left scrolled past it. */
(function () {
  function setup(el) {
    if (el.bsCollapse) return; el.bsCollapse = true;
    var h = parseInt(el.getAttribute('data-bs-collapse-height'), 10) || 900;
    el.style.setProperty('--bs-collapse-h', h + 'px');
    var inner = el.querySelector(':scope > .bs-collapse-inner') || el;
    var toggle = el.parentElement && el.parentElement.querySelector('[data-bs-collapse-toggle]');
    /* An app widget (Loox) that has not drawn yet: hold the collapsed height, fade and button from first paint, so the
       sections below never jump down when the reviews arrive. The hold ends once the reviews fill the box, or 8 s after
       the page has loaded for a product with only a few (the box then shrinks to fit). */
    var hold = inner !== el && !!inner.querySelector('.shopify-app-block, .loox-widget') && inner.getBoundingClientRect().height < h;
    function check() {
      /* a little over the limit just shows in full: a fade and a button to reveal a sliver read as a bug */
      var tall = (inner === el ? el.scrollHeight : inner.getBoundingClientRect().height) > h + 160;
      if (hold && tall) release();
      if (hold) return;
      el.classList.toggle('is-fit', !tall && !el.classList.contains('is-open'));
    }
    function release() { if (!hold) return; hold = false; el.classList.remove('is-wait'); check(); }
    if (hold) {
      el.classList.add('is-wait');
      var late = function () { setTimeout(release, 8000); };
      if (document.readyState === 'complete') late(); else window.addEventListener('load', late);
    }
    check();
    if ('ResizeObserver' in window && inner !== el) new ResizeObserver(check).observe(inner);
    else {
      var mo = new MutationObserver(check); mo.observe(el, { childList: true, subtree: true, attributes: true });
      window.addEventListener('load', check);
    }
    var rt; window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(check, 120); });
    if (toggle) {
      var moreText = toggle.textContent, lessText = toggle.getAttribute('data-bs-collapse-less') || moreText;
      toggle.addEventListener('click', function () {
        var opening = !el.classList.contains('is-open');
        el.classList.toggle('is-open', opening);
        toggle.setAttribute('aria-expanded', opening ? 'true' : 'false');
        toggle.textContent = opening ? lessText : moreText;
        if (!opening) {
          check();
          var section = toggle.closest('section') || el.closest('section');
          if (section) section.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    }
  }
  function scan(root) { [].forEach.call((root || document).querySelectorAll('[data-bs-collapse]'), setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); });
  else scan();
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
